import React, { useState } from 'react';
import { trackEPassPageEvent } from '../../utils/omnitureTracking';

type EPassInfoProps = {
  isMobileDevice: boolean;
};
const EPassInfo = ({ isMobileDevice }: EPassInfoProps) => {
  const infoPrefix = `e-Pass is a document which you’re required to furnish upon arrival at a destination, as per the guidelines issued by specific states. You can apply for an e-Pass on the respective state government sites  wherever specified as mandatory. You will be required to input cab/driver details and other necessary documents on the respective state government site as a part of the application process `;
  const infoSuffix = `. Once the application is submitted, it’ll be sent to the respective authorities for examination. If your application is approved, the respective department will inform you of the same via SMS. You can also visit their site to check the status of your application. Once an e-Pass is issued, you’re required to carry it with you during travel and furnish it whenever requested by the officials. `;
  const [readMore, setReadMore] = useState(false);

  return (
    <div
      className={`epass__details section__bdr ${
        isMobileDevice ? 'mobileShow' : 'desktopShow'
      }`}
    >
      {!isMobileDevice ? (
        <div className="about__epass__img">&nbsp;</div>
      ) : (
        <></>
      )}
      <div className="epass__info dark__text">
        <p className="section__heading latoBlack">What is an e-Pass?</p>
        <p className="epass__details__text">
          {!readMore ? (
            <>
              <span>{`${infoPrefix}... `}</span>
              <span>
                <a
                  style={{ whiteSpace: 'nowrap' }}
                  className="blueText latoBold capText"
                  onClick={() => {
                    trackEPassPageEvent('Cab_SEO_Epass_Readmore_Click');
                    setReadMore(!readMore);
                  }}
                >
                  Read More
                </a>
              </span>
            </>
          ) : (
            <>
              <span>{infoPrefix}</span>
              {/* <a className="blueText latoBold capText " id="knowMore" style={{ whiteSpace: "nowrap" }}> KNOW MORE</a> */}
              <span>{infoSuffix}</span>
              <span>
                <a
                  style={{ whiteSpace: 'nowrap' }}
                  className="blueText latoBold capText"
                  onClick={() => setReadMore(!readMore)}
                >
                  Read less
                </a>
              </span>
            </>
          )}
        </p>
      </div>
    </div>
  );
};
export default EPassInfo;
